(() => {
  'use strict';

  const CUSTOMIZER_URL = '/pages/customizer';

  const DB_NAME = 'pp3d-universal-upload';
  const STORE_NAME = 'uploads';
  const FILE_KEY = 'pending-file';


  function openDb() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, 1);

      request.onupgradeneeded = () => {
        const db = request.result;

        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      };

      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  }


  async function saveFile(file) {
    const db = await openDb();

    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');

      tx.objectStore(STORE_NAME).put(
        file,
        FILE_KEY
      );

      tx.oncomplete = () => {
        db.close();
        resolve();
      };

      tx.onerror = () => {
        db.close();
        reject(tx.error);
      };
    });
  }


  function getGlobalInput() {
    let input = document.querySelector(
      '[data-pillow-global-input]'
    );

    if (input) {
      return input;
    }

    input = document.createElement('input');

    input.type = 'file';

    input.accept =
      'image/jpeg,image/png,image/webp';

    input.style.display = 'none';

    input.setAttribute(
      'data-pillow-global-input',
      ''
    );

    document.body.appendChild(input);

    return input;
  }


  /*
   * IMPORTANT:
   * capture:true means this runs BEFORE
   * slideshow/theme link handlers.
   */
  document.addEventListener(
    'click',

    function (event) {

      const trigger = event.target.closest(
        '[data-pillow-upload-trigger]'
      );

      if (!trigger) return;


      /*
       * STOP normal link navigation.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      /*
       * If already on customizer page,
       * use its existing file input.
       */
      const existingCustomizerInput =
        document.querySelector('[data-pp3d-file]');

      if (existingCustomizerInput) {

        existingCustomizerInput.value = '';

        existingCustomizerInput.click();

        return;
      }


      /*
       * Home / About / any other page
       */
      const input = getGlobalInput();

      input.value = '';


      input.onchange = async function () {

        const file = input.files?.[0];

        if (!file) return;


        if (
          ![
            'image/jpeg',
            'image/png',
            'image/webp'
          ].includes(file.type)
        ) {

          alert(
            'Please choose a JPG, PNG, or WebP image.'
          );

          return;
        }


        try {

          /*
           * Store selected image temporarily.
           */
          await saveFile(file);


          /*
           * NOW go to customizer.
           */
          window.location.href =
            CUSTOMIZER_URL +
            '?pillow-upload=1';


        } catch (error) {

          console.error(
            'Pillow universal upload error:',
            error
          );

          alert(
            'Could not start the pillow customizer. Please try again.'
          );
        }
      };


      /*
       * File picker must open directly
       * from customer's click.
       */
      input.click();

    },

    true
  );

})();

/* ==========================================================
   PP3D FAST UPLOAD ADD-ON
   - Sends a resized copy (max 2400px JPEG) to the processing
     server, so big phone photos upload fast and never hit the
     server size limit / timeout.
   - The FULL-SIZE original is still saved for the order
     (customizer sets originalFile before calling the server).
   - Replaces the progress bar that froze at 90% with a smooth
     bar and step-by-step status messages.
   ========================================================== */
(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-pp3d-v15-root]';
  const MAX_DIM = 2400;
  const QUALITY = 0.93;
  const SKIP_BELOW_BYTES = 2.5 * 1024 * 1024;

  const STEPS = [
    [0, 'Uploading your photo...'],
    [2500, 'Removing the background...'],
    [7000, 'Tracing the outline...'],
    [12000, 'Shaping your pillow...'],
    [20000, 'Adding the finishing touches...'],
    [30000, 'Almost ready, thanks for waiting...']
  ];

  function loadImg(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  }

  async function shrinkForServer(file) {
    if (!file || !String(file.type || '').startsWith('image/')) return file;

    let bitmap = null;
    let url = null;

    try {
      let img = null;

      if ('createImageBitmap' in window) {
        try {
          bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
          img = bitmap;
        } catch (_) {
          bitmap = null;
        }
      }

      if (!img) {
        url = URL.createObjectURL(file);
        img = await loadImg(url);
      }

      const w0 = Math.max(1, img.naturalWidth || img.width || 1);
      const h0 = Math.max(1, img.naturalHeight || img.height || 1);
      const scale = Math.min(1, MAX_DIM / Math.max(w0, h0));

      // Already small: send as-is.
      if (scale === 1 && file.size <= SKIP_BELOW_BYTES) return file;

      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(w0 * scale));
      canvas.height = Math.max(1, Math.round(h0 * scale));

      const ctx = canvas.getContext('2d');
      if (!ctx) return file;

      // White under transparent PNGs so JPEG does not turn them black.
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', QUALITY));
      if (!blob || blob.size <= 0 || blob.size >= file.size) return file;

      const base = String(file.name || 'pillow-photo').replace(/\.[^.]+$/, '');
      console.info('PP3D fast upload:', (file.size / 1048576).toFixed(1) + ' MB ->', (blob.size / 1048576).toFixed(2) + ' MB');
      return new File([blob], base + '-preview.jpg', { type: 'image/jpeg' });

    } catch (error) {
      console.warn('PP3D fast upload: could not resize, sending original', error);
      return file;
    } finally {
      try { if (bitmap && bitmap.close) bitmap.close(); } catch (_) {}
      if (url) URL.revokeObjectURL(url);
    }
  }

  function enhanceCanvas(canvas) {
    const w = canvas.width;
    const h = canvas.height;
    if (!w || !h || w * h > 6000000) return;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    const img = ctx.getImageData(0, 0, w, h);
    const src = img.data;
    const out = new Uint8ClampedArray(src);
    const AMOUNT = 0.35;     // sharpening strength
    const CONTRAST = 1.05;
    const SATURATION = 1.10;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        const i = (y * w + x) * 4;
        if (src[i + 3] < 8) continue;
        const up = y > 0 ? i - w * 4 : i;
        const dn = y < h - 1 ? i + w * 4 : i;
        const lf = x > 0 ? i - 4 : i;
        const rt = x < w - 1 ? i + 4 : i;
        const a = src[up + 3] > 200 ? up : i;
        const b = src[dn + 3] > 200 ? dn : i;
        const l = src[lf + 3] > 200 ? lf : i;
        const r = src[rt + 3] > 200 ? rt : i;
        const k = AMOUNT * 4;
        const R = src[i] + k * (src[i] - (src[a] + src[b] + src[l] + src[r]) / 4);
        const G = src[i + 1] + k * (src[i + 1] - (src[a + 1] + src[b + 1] + src[l + 1] + src[r + 1]) / 4);
        const B = src[i + 2] + k * (src[i + 2] - (src[a + 2] + src[b + 2] + src[l + 2] + src[r + 2]) / 4);
        const gray = 0.299 * R + 0.587 * G + 0.114 * B;
        out[i] = (gray + (R - gray) * SATURATION - 128) * CONTRAST + 128;
        out[i + 1] = (gray + (G - gray) * SATURATION - 128) * CONTRAST + 128;
        out[i + 2] = (gray + (B - gray) * SATURATION - 128) * CONTRAST + 128;
      }
    }
    img.data.set(out);
    ctx.putImageData(img, 0, 0);
  }

  function patch(proto) {
    if (!proto || proto.__ppFastUploadPatched) return;
    if (typeof proto.processImageOnServer !== 'function') return;
    proto.__ppFastUploadPatched = true;

    // 1) Resize before sending to the server.
    const origProcess = proto.processImageOnServer;
    proto.processImageOnServer = async function (file) {
      const small = await shrinkForServer(file);
      return origProcess.call(this, small);
    };

    // 2) Progress messages stop once the server is done.
    const origUpdate = proto.updateProgress;
    if (typeof origUpdate === 'function') {
      proto.updateProgress = function (text) {
        if (/Building 3D Pillow/i.test(String(text || ''))) this.ppFastMessages = false;
        return origUpdate.call(this, text);
      };
    }

    const origStop = proto.stopFakeProgress;
    if (typeof origStop === 'function') {
      proto.stopFakeProgress = function () {
        this.ppFastMessages = false;
        return origStop.call(this);
      };
    }

    // 4) See Size (2D) - real-world scale (like AllAboutVibe):
    //    - Small/Medium/Large: the size is the pillow's LONGEST side.
    //    - Extra Large: life-size, short side 34in, long side max 60in.
    //    - Pillow is drawn to the same scale as the scene (sofa seat
    //      18in, woman 5'4") and placed on the seat / floor.
    if (typeof proto.getDynamicPillowDimensions === 'function') {
      proto.getDynamicPillowDimensions = function (cropCanvas, nominalSize) {
        const w0 = Math.max(1, Number(cropCanvas && cropCanvas.width) || 1);
        const h0 = Math.max(1, Number(cropCanvas && cropCanvas.height) || 1);
        const aspectRatio = Math.max(0.12, Math.min(8, w0 / h0));
        const size = Math.max(1, Number(nominalSize) || 16);
        let width;
        let height;
        if (size >= 60) {
          const SHORT = 34;
          if (aspectRatio >= 1) { height = SHORT; width = SHORT * aspectRatio; }
          else { width = SHORT; height = SHORT / aspectRatio; }
          const longest = Math.max(width, height);
          if (longest > size) { width *= size / longest; height *= size / longest; }
        } else {
          width = aspectRatio >= 1 ? size : size * aspectRatio;
          height = aspectRatio >= 1 ? size / aspectRatio : size;
        }
        return { width, height, aspectRatio, targetArea: width * height };
      };
    }

    if (typeof proto.getSize2dConfig === 'function') {
      const origConfig = proto.getSize2dConfig;
      // Measured on the square scene images:
      //   sofa scene (S/M/L): 1.41% of image per inch, seat at 40% from bottom
      //   standing scene (XL): 1.136% per inch (woman 64in = 72.7%), floor at 9.5%
      const SCENES = {
        sofa: { perInch: 0.0141, anchor: 0.40 },
        standing: { perInch: 0.01136, anchor: 0.095 }
      };
      proto.getSize2dConfig = function (inches) {
        const cfg = Object.assign({}, origConfig.call(this, inches));
        try {
          const r = this.dom && this.dom.stageWrap && this.dom.stageWrap.getBoundingClientRect();
          if (!r || !r.width || !r.height) return cfg;
          const n = Number(inches) || 16;
          const scene = n >= 60 ? SCENES.standing : SCENES.sofa;
          const img = Math.max(r.width, r.height); // object-fit: cover on a square image
          const pxPerInch = scene.perInch * img;
          const p = this.state && this.state.pillows && this.state.pillows[this.state.activeSlotIndex];
          const c = p && p.cropCanvas;
          const a = c ? c.width / Math.max(1, c.height) : 1;
          const boost = (n === 60 && a >= 1.15) ? 1.22 : 1; // cancel old XL boost
          const center = cfg.leftPct + cfg.maxWidthPct / 2;
          cfg.maxWidthPct = (pxPerInch * n / r.width) * 100 / boost;
          cfg.heightPct = (pxPerInch * n / r.height) * 100;
          cfg.leftPct = center - cfg.maxWidthPct / 2;
          const cropBottom = (img - r.height) / 2;
          cfg.bottomPct = Math.max(0, (scene.anchor * img - cropBottom) / r.height * 100);
        } catch (_) {}
        return cfg;
      };
    }

    // 5) Sharper, livelier 3D preview.
    //    a) Phones were rendered at 1x resolution with no anti-aliasing
    //       (blurry on 2x/3x screens). Now up to 2x + anti-aliasing.
    if (typeof proto.setupThree === 'function') {
      const origSetup = proto.setupThree;
      proto.setupThree = function () {
        if (this.renderer) return origSetup.apply(this, arguments);
        const wasMobile = this.isMobile;
        this.isMobile = false;
        try {
          return origSetup.apply(this, arguments);
        } finally {
          this.isMobile = wasMobile;
          try {
            // Match the phone's real screen sharpness (iPhones are 3x).
            if (this.renderer) this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 3));
          } catch (_) {}
        }
      };
    }

    //    b) Gentle sharpening + a touch of colour so fur and eyes keep their
    //       detail on the 3D/2D preview (the order still uses the original photo).
    if (typeof proto.cropTransparent === 'function') {
      const origCrop = proto.cropTransparent;
      proto.cropTransparent = async function () {
        const canvas = await origCrop.apply(this, arguments);
        try { enhanceCanvas(canvas); console.info('PP3D preview texture:', canvas.width + 'x' + canvas.height); } catch (e) { console.warn('PP3D enhance skipped', e); }
        return canvas;
      };
    }

    //    c) Best texture filtering the device supports.
    if (typeof proto.createPhotoTexture === 'function') {
      const origTex = proto.createPhotoTexture;
      proto.createPhotoTexture = function () {
        const tex = origTex.apply(this, arguments);
        try {
          tex.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
          tex.needsUpdate = true;
        } catch (_) {}
        return tex;
      };
    }

    // 3) Smooth progress that never looks frozen.
    if (typeof proto.setLoadingPercent === 'function') {
      proto.startFakeProgress = function () {
        this.stopFakeProgress();

        let value = 0;
        const started = Date.now();
        this.ppFastMessages = true;
        this.setLoadingPercent(value);

        this.loadingPercentTimer = setInterval(() => {
          value += (97 - value) * 0.045;
          this.setLoadingPercent(value);

          if (this.ppFastMessages && typeof this.updateProgress === 'function') {
            const elapsed = Date.now() - started;
            let text = STEPS[0][1];
            for (const [t, msg] of STEPS) {
              if (elapsed >= t) text = msg;
            }
            this.updateProgress(text);
          }
        }, 350);
      };
    }
  }

  function tryPatch() {
    const roots = document.querySelectorAll(ROOT_SELECTOR);
    for (const root of roots) {
      if (root.__pp3dV15) {
        patch(Object.getPrototypeOf(root.__pp3dV15));
        return true;
      }
    }
    return false;
  }

  // Only runs on pages that have the customizer.
  if (!document.querySelector(ROOT_SELECTOR) && document.readyState !== 'loading') return;

  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (tryPatch() || tries > 100) clearInterval(timer);
  }, 100);

  document.addEventListener('shopify:section:load', () => setTimeout(tryPatch, 300));
})();

/* ==========================================================
   CLEAN CART ADD-ON
   - No "I agree with the terms and conditions" checkbox:
     checkout / Buy now work straight away.
   - Cart drawer shows the customer's own pet pillow preview
     (saved with the item as "Pillow Preview") instead of the
     stock product photo.
   - "Free shipping" wording under the cart total.
   ========================================================== */
(() => {
  'use strict';

  function skipTerms(root) {
    (root || document).querySelectorAll('checkout-button, buy-now').forEach(function (el) {
      if (el.__ppNoTerms) return;
      el.__ppNoTerms = true;
      var box = el.querySelector('.checkbox__input');
      if (box) {
        box.checked = true;
        var wrap = box.closest('.d-flex.pb-4, .d-flex.pb-3') || box.closest('.checkbox');
        if (wrap) wrap.style.setProperty('display', 'none', 'important');
      }
      el.querySelectorAll('.disabled').forEach(function (d) { d.classList.remove('disabled'); });
    });
  }

  function freeShippingText() {
    document.querySelectorAll('.mini-cart-taxes').forEach(function (el) {
      var t = 'Free shipping · Taxes calculated at checkout';
      if (el.textContent.trim() !== t) el.textContent = t;
    });
  }

  var busy = false, again = false;
  function petImages() {
    var nodes = document.querySelectorAll('.mini-cart-item');
    if (!nodes.length) return;
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        document.querySelectorAll('.mini-cart-item').forEach(function (node, i) {
          var it = items[i]; if (!it || !it.properties) return;
          var p = it.properties['Pillow Preview'] || it.properties['Original Photo'];
          if (!p || !/^https?:\/\//.test(String(p))) return;
          var img = node.querySelector('.mini-cart-image img');
          if (img && img.getAttribute('src') !== p) {
            img.src = p;
            img.removeAttribute('srcset');
            img.alt = 'Your pet pillow';
            img.style.objectFit = 'contain';
            img.style.background = '#fff';
          }
          var title = node.querySelector('.mini-cart-meta a');
          if (title && !title.__ppTitled) {
            title.__ppTitled = true;
            var size = it.variant_title ? ' – ' + it.variant_title : '';
            title.textContent = 'Custom Pet Pillow' + size;
          }
        });
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; petImages(); } });
  }

  // The customizer's own product has no photo upload, so customers must never
  // land on it: every link to it (cart items included) opens the builder,
  // and opening the product page directly sends people to the builder.
  var BUILDER = '/pages/customizer';
  var HIDDEN_PRODUCTS = ['custom-create-pillow'];
  function isHidden(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return !!(m && HIDDEN_PRODUCTS.indexOf(m[1]) > -1);
  }
  function redirectProductPage() {
    if (window.Shopify && Shopify.designMode) return;
    if (isHidden(location.pathname)) location.replace(BUILDER);
  }
  function fixLinks() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (!isHidden(a.getAttribute('href'))) return;
      a.setAttribute('href', BUILDER);
    });
  }
  redirectProductPage();

  // Buy 2 Get 1 FREE progress (automatic discount on the custom pillow:
  // 3 pillows = 3rd one free) shown in the cart drawer and on the cart page.
  function offerHtml(n) {
    var msg;
    if (n <= 1) msg = 'Buy 2, get 1 FREE – add <b>2 more pillows</b> and the 3rd is <b>FREE</b>';
    else if (n === 2) msg = 'Almost there! Add <b>1 more pillow</b> and it’s <b>FREE</b>';
    else msg = '🎉 <b>Free pillow applied!</b> You’re getting the best deal';
    var steps = '';
    for (var k = 1; k <= 3; k++) {
      var on = n >= k;
      var label = k === 1 ? '1st pillow' : (k === 2 ? '2nd pillow' : '3rd FREE');
      steps += '<span style="flex:1;text-align:center;padding:6px 4px;border-radius:999px;font-size:12px;font-weight:700;' +
        (on ? 'background:#d64f7d;color:#fff;' : 'background:#fff;color:#8a5a6a;border:1px solid #f1c6d4;') + '">' + label + '</span>';
    }
    return '<div style="font-size:14px;line-height:1.4;margin:0 0 8px;color:#4a2234">' + msg + '</div>' +
      '<div style="display:flex;gap:6px">' + steps + '</div>';
  }
  function placeOffer(container, n, where) {
    if (!container) return;
    var box = container.parentNode && container.parentNode.querySelector(':scope > .pp-offer');
    if (!n) { if (box) box.remove(); return; }
    if (!box) {
      box = document.createElement('div');
      box.className = 'pp-offer';
      box.style.cssText = 'background:#fdf0f4;border:1px solid #f6d3df;border-radius:14px;padding:12px;margin:' + (where === 'page' ? '0 0 16px' : '0 0 12px');
      container.parentNode.insertBefore(box, container);
    }
    var html = offerHtml(n);
    if (box.__html !== html) { box.innerHTML = html; box.__html = html; }
  }
  var offerBusy = false;
  function offerBar() {
    var drawer = document.querySelector('.js-mini-cart-content');
    var page = document.querySelector('.cart-table');
    if (!drawer && !page) return;
    if (offerBusy) return; offerBusy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        placeOffer(drawer, n, 'drawer');
        placeOffer(page, n, 'page');
      })
      .catch(function () {})
      .then(function () { offerBusy = false; });
  }
  // Drawer shows "$67.00 x 1" next to the quantity box: drop the duplicate "x 1".
  function tidyQty() {
    document.querySelectorAll('.mini-cart-meta').forEach(function (m) {
      Array.prototype.slice.call(m.childNodes).forEach(function (n) {
        if (n.nodeType === 3 && /^\s*x\s*\d+\s*$/.test(n.textContent)) n.textContent = ' ';
      });
    });
  }

  // Create Pillow page: clearer upload button wording.
  function ctaText() {
    document.querySelectorAll('.pp3d-entry-upload-btn > span').forEach(function (s) {
      if (/^\s*TURN MY PHOTO INTO A PILLOW\s*$/i.test(s.textContent)) s.textContent = 'UPLOAD PHOTO & SEE YOUR PET AS A PILLOW';
    });
  }

  function run() { skipTerms(); freeShippingText(); petImages(); fixLinks(); tidyQty(); offerBar(); ctaText(); }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-qty__adjust, .js-remove-mini-cart, .cart__remove, [href*="/cart/change"]')) setTimeout(run, 900);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.change-minicart, .cart__quantity, .js-qty__input')) setTimeout(run, 900);
  }, true);

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(run, 80); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && (n.matches('.mini-cart-item, checkout-button, buy-now, a[href*="/products/"]') || n.querySelector('.mini-cart-item, checkout-button, buy-now, a[href*="/products/"]'))) { schedule(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ==========================================================
   FAST ADD TO CART
   - Print file and a small JPEG preview are prepared in the
     background as soon as the pillow is ready, so the button
     only has to upload.
   - Preview image sent to the cart is a ~700px JPEG (was a
     1-2 MB PNG). Original photo and print PNG are unchanged.
   - Button shows real upload progress.
   ========================================================== */
(() => {
  'use strict';

  var ROOT = '[data-pp3d-v15-root]';
  var PREVIEW_MAX = 700;

  function toBlob(canvas, type, q) {
    return new Promise(function (res, rej) {
      canvas.toBlob(function (b) { b ? res(b) : rej(new Error('Could not prepare custom image.')); }, type, q);
    });
  }
  function loadImg(src) {
    return new Promise(function (res, rej) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = rej; i.src = src; });
  }
  async function smallPreview(src, fallback) {
    var img = fallback;
    if (src) { try { img = await loadImg(src); } catch (_) { img = fallback; } }
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    var s = Math.min(1, PREVIEW_MAX / Math.max(w, h));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * s)); c.height = Math.max(1, Math.round(h * s));
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, c.width, c.height);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, c.width, c.height);
    return toBlob(c, 'image/jpeg', 0.86);
  }

  var printCache = new WeakMap();
  function printBlob(canvas) {
    if (!printCache.has(canvas)) {
      var pr = toBlob(canvas, 'image/png');
      pr.catch(function () { printCache.delete(canvas); });
      printCache.set(canvas, pr);
    }
    return printCache.get(canvas);
  }
  function previewBlob(p) {
    var v = p.__ppPrev;
    if (!v || v.thumb !== p.thumbUrl || v.canvas !== p.cropCanvas) {
      v = { thumb: p.thumbUrl, canvas: p.cropCanvas, promise: smallPreview(p.thumbUrl, p.cropCanvas) };
      v.promise.catch(function () { if (p.__ppPrev === v) p.__ppPrev = null; });
      p.__ppPrev = v;
    }
    return v.promise;
  }
  window.__ppFiles = { printBlob: printBlob, previewBlob: previewBlob };

  function scheduleWarm(inst) {
    clearTimeout(inst.__ppWarmT);
    inst.__ppWarmT = setTimeout(function () {
      var run = function () {
        (inst.state.pillows || []).forEach(function (p) {
          if (p && p.cropCanvas && p.meshGroup) { printBlob(p.cropCanvas).catch(function () {}); previewBlob(p).catch(function () {}); }
        });
      };
      if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 2500 }); else run();
    }, 1200);
  }

  function xhrAdd(url, fd, onProgress) {
    return new Promise(function (res, rej) {
      var x = new XMLHttpRequest();
      x.open('POST', url);
      x.setRequestHeader('Accept', 'application/json');
      if (x.upload) x.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(e.loaded, e.total); };
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) return res();
        var m = 'Could not add item to cart.';
        try { var j = JSON.parse(x.responseText); m = j.description || j.message || m; } catch (_) {}
        rej(new Error(m));
      };
      x.onerror = function () { rej(new Error('Upload failed. Please check your connection and try again.')); };
      x.send(fd);
    });
  }

  function patch(inst) {
    var proto = Object.getPrototypeOf(inst);
    if (!proto || proto.__ppFastCart) return;
    proto.__ppFastCart = true;

    var origSlot = proto.updateBundleSlotUI;
    if (typeof origSlot === 'function') {
      proto.updateBundleSlotUI = function () { var r = origSlot.apply(this, arguments); try { scheduleWarm(this); } catch (_) {} return r; };
    }

    proto.handleAddToCart = async function (mode) {
      var self = this;
      var entries = this.state.pillows.map(function (p, index) { return { p: p, index: index }; }).filter(function (x) { return x.p.meshGroup && x.p.cropCanvas; });
      if (!entries.length) { this.showToast('Upload a photo first.'); this.openUploadModal(0); return; }
      var btn = this.dom.addToCartBtn;
      var buy = this.root.querySelector('.pp-buy-now');
      if (btn.disabled || this.__ppBusy) return;
      this.__ppBusy = true;

      var checkout = mode === 'checkout' && !!buy;
      var active = checkout ? buy : btn;
      var txt = checkout ? buy.querySelector('.pp-buy-now__main') : this.dom.btnActionTxt;
      var old = txt.textContent;
      var setText = function (t) { txt.textContent = t; };
      var reset = function () {
        self.__ppBusy = false;
        btn.disabled = false; if (buy) buy.disabled = false;
        active.classList.remove('pp3d-cart-loading');
        setText(old);
      };

      btn.disabled = true; if (buy) buy.disabled = true;
      active.classList.add('pp3d-cart-loading');
      setText('PREPARING YOUR PILLOW...');

      try {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var forms = [];
        for (var k = 0; k < entries.length; k++) {
          var p = entries[k].p, index = entries[k].index;
          var size = this.getSize(p.size);
          if (!size || !size.id) throw new Error('A valid Shopify size variant was not found.');
          var stamp = Date.now();
          var fd = new FormData();
          fd.append('id', String(size.id));
          fd.append('quantity', '1');
          var urls = null, bytes = 2000;
          if (window.__ppSavedUrls) {
            setText('SAVING YOUR PHOTO...');
            try { urls = await window.__ppSavedUrls(p); } catch (_) { urls = null; }
          }
          if (urls && urls.print && urls.preview) {
            if (urls.orig) fd.append('properties[Original Photo]', urls.orig);
            fd.append('properties[Pillow Preview]', urls.preview);
            fd.append('properties[_Print File]', urls.print);
          } else {
            var files = await Promise.all([printBlob(p.cropCanvas), previewBlob(p)]);
            if (p.originalFile) fd.append('properties[Original Photo]', p.originalFile, p.originalFile.name || ('original-photo-' + (index + 1) + '.jpg'));
            fd.append('properties[Pillow Preview]', new File([files[1]], 'pillow-preview-' + stamp + '-' + (index + 1) + '.jpg', { type: 'image/jpeg' }));
            fd.append('properties[_Print File]', new File([files[0]], 'print-' + stamp + '-' + (index + 1) + '.png', { type: 'image/png' }));
            bytes = (p.originalFile ? p.originalFile.size : 0) + files[0].size + files[1].size;
          }
          fd.append('properties[Pillow Size]', size.label);
          if (p.note && p.note.trim()) fd.append('properties[Notes]', p.note.trim());
          fd.append('properties[Border Color]', p.borderColor);
          fd.append('properties[_Customizer]', 'Rounded 3D Pillow V7');
          fd.append('properties[_Pillow Slot]', String(index + 1));
          if (entries.length === 3) fd.append('properties[_Bundle]', 'Buy 2 Get 1 Free');
          forms.push({ fd: fd, bytes: bytes });
        }

        var total = forms.reduce(function (a, f) { return a + f.bytes; }, 0) || 1;
        var done = 0;
        setText('UPLOADING YOUR PHOTO... 0%');
        for (var i = 0; i < forms.length; i++) {
          var f = forms[i];
          await xhrAdd(root + 'cart/add.js', f.fd, function (loaded) {
            var pct = Math.min(99, Math.round((done + Math.min(loaded, f.bytes)) / total * 100));
            setText('UPLOADING YOUR PHOTO... ' + pct + '%');
          });
          done += f.bytes;
        }

        var discount = (this.root.dataset.bundleDiscountCode || '').trim();
        if (entries.length === 3 && discount) {
          var r = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: discount }) });
          if (!r.ok) console.warn('PP3D discount code could not be applied automatically.');
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (checkout) { setText('OPENING SECURE CHECKOUT...'); window.location.href = root + 'checkout'; return; }

        setText('ADDED TO CART ✓');
        this.showToast('Added to cart!');
        if (this.root.dataset.redirectCart === 'true') { window.location.href = root + 'cart'; return; }
        setTimeout(reset, 900);
      } catch (err) {
        console.error('PP3D cart error', err);
        this.showToast((err && err.message) || 'Could not add to cart.');
        reset();
      }
    };
  }

  function tryPatch() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__pp3dV15) { patch(roots[i].__pp3dV15); return true; }
    }
    return false;
  }

  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    if (tryPatch() || tries > 150 || (tries > 30 && !document.querySelector(ROOT))) clearInterval(timer);
  }, 100);
  document.addEventListener('shopify:section:load', function () { setTimeout(tryPatch, 300); });
})();

/* ==========================================================
   BUILDER LAYOUT (like the best-selling customizers)
   - After upload: sizes + prices first, then Add to Cart,
     Buy Now (express checkout), delivery line, then the
     Buy 2 Get 1 boxes.
   - Delivery line: "Printed in 3–5 days · Free shipping".
   ========================================================== */
(() => {
  'use strict';
  var SHIP_TEXT = 'Printed in 3–5 days · Free shipping';
  if (!document.getElementById('pp-layout-css')) {
    var st = document.createElement('style');
    st.id = 'pp-layout-css';
    st.textContent =
      '.customizer-controls .pp3d-after-generate-options:not([hidden]){display:contents}' +
      '.customizer-controls .size-cards-grid{order:1}' +
      '.customizer-controls .pp3d-purchase-area{order:2}' +
      '.customizer-controls .bundle-section-wrap{order:3}';
    document.head.appendChild(st);
  }
  function shipText() {
    document.querySelectorAll('.shipping-notice-line > span:last-child').forEach(function (s) {
      if (s.textContent !== SHIP_TEXT) s.textContent = SHIP_TEXT;
    });
  }
  function run() { shipText(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var n = 0, t = setInterval(function () { run(); if (++n > 40) clearInterval(t); }, 250);
})();

/* ==========================================================
   SHOPIFY EXPRESS CHECKOUT + BUY BUTTONS FROM THE FIRST SCREEN
   - Photos are saved on api.custompetshop.com as soon as the
     pillow preview is ready, so Shopify's own express buttons
     (Shop Pay / Apple Pay / Google Pay) carry them as links.
   - Before a photo is ready, Add to Cart and the express
     buttons open the photo picker instead (no photo-less
     orders).
   ========================================================== */
(() => {
  'use strict';
  var API = 'https://api.custompetshop.com/api/save-photo';
  var ROOT = '[data-pp3d-v15-root]';

  if (!document.getElementById('pp-xb-css')) {
    var st = document.createElement('style');
    st.id = 'pp-xb-css';
    st.textContent =
      '.pp-xb{position:relative;margin-top:10px}.pp-xb__pay{position:relative}' +
      '.pp-xb__lock{position:absolute;inset:0;z-index:5;cursor:pointer;background:transparent}' +
      '.pp-xb__hint{display:none;font-size:12px;text-align:center;color:#8a5a6a;margin-top:6px}' +
      '.pp-xb[data-state="busy"] .pp-xb__hint{display:block}.pp-xb[data-state="busy"] .pp-xb__pay{opacity:.6}' +
      '.pp-early{margin:12px 0 10px}' +
      '.pp-early__head{display:flex;justify-content:space-between;align-items:center;margin:0 0 7px}' +
      '.pp-early__title{font-size:12px;font-weight:800;letter-spacing:1px;text-transform:uppercase;color:#5b2147;margin:0}' +
      '.pp-early__ship{font-size:12px;color:#2e7d4f;font-weight:700}' +
      '.pp-early__grid{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}' +
      '.pp-early__card{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1px;min-height:50px;padding:7px 2px 6px;border:1.5px solid #e9e1ef;border-radius:10px;background:#fff;color:#2b1a26;font:inherit;cursor:pointer;line-height:1.15;transition:border-color .15s,background .15s}' +
      '.pp-early__card b{font-size:12.5px;font-weight:700;white-space:nowrap}' +
      '.pp-early__card span{font-size:15px;font-weight:800;color:#d94f7c}' +
      '.pp-early__card.is-on{border-color:#5b2147;background:#5b2147;color:#fff}.pp-early__card.is-on span{color:#ffd1e1}' +
      '.pp-early__badge{position:absolute;top:-8px;left:50%;transform:translateX(-50%);background:#d94f7c;color:#fff;font-size:8.5px;font-style:normal;font-weight:800;letter-spacing:.4px;padding:1px 6px;border-radius:999px;white-space:nowrap}' +
      '.pp-hero-head{text-align:center;margin:0 0 12px}' +
      '.pp-hero-title{font-family:Platypi,Georgia,serif;font-weight:800;color:#5b2147;font-size:27px;line-height:1.12;margin:0;letter-spacing:-.2px}' +
      '.pp-hero-sub{margin:5px 0 0;font-size:13.5px;color:#4a3a45;font-weight:600}.pp-hero-sub .pp-stars{color:#f5a623;letter-spacing:1px;margin-right:4px}' +
      '.pp3d-purchase-area>.pp-xb{margin-top:-2px}' +
      '.pp-xb-parked{position:absolute!important;left:-10000px!important;top:0!important;width:355px!important;visibility:hidden!important}' +
      '[data-pp3d-v15-root] .customizer-card .customizer-controls .pp3d-after-generate-options[hidden]{display:contents!important}' +
      '[data-pp3d-v15-root] .customizer-card .customizer-controls .pp3d-after-generate-options .size-cards-grid{visibility:visible!important;opacity:1!important;pointer-events:auto!important}' +
      '[data-pp3d-v15-root] .pp3d-entry-upload-btn{min-height:58px!important;margin-top:0!important;gap:10px}' +
      '[data-pp3d-v15-root] .pp3d-entry-upload-btn>span{font-size:0!important;line-height:0}' +
      '[data-pp3d-v15-root] .pp3d-entry-upload-btn>span::before{content:"UPLOAD YOUR PET\\2019S PHOTO";font-size:17px;line-height:1.2;font-weight:800;letter-spacing:.4px;white-space:nowrap}' +
      '[data-pp3d-v15-root] .pp3d-entry-screen::after{content:"\\2713  Free design proof before we print  \\00b7  Printed in 3\\2013 5 days";display:block;text-align:center;font-size:12.5px;color:#6b5563;margin:10px 0 4px}' +
      '[data-pp3d-v15-root] .size-placeholder-shape{opacity:.35}' +
      '.pp-xb shopify-accelerated-checkout{--shopify-accelerated-checkout-button-border-radius:14px;--shopify-accelerated-checkout-button-block-size:54px;--shopify-accelerated-checkout-inline-alignment:center}' +
      '@media (max-width:749px){' +
        '.pp-hero-title{font-size:25px}' +
        '[data-pp3d-v15-root] .pp3d-entry-screen{--pp-entry-mobile-ratio:3 / 2!important}' +
        '[data-pp3d-v15-root] .pp3d-entry-main-media{aspect-ratio:3 / 2!important;height:auto!important;min-height:0!important}' +
        '[data-pp3d-v15-root] .pp3d-entry-main-image{object-position:50% 22%!important}' +
        '.customizer-app.pp3d-v15{padding-top:12px!important}' +
        '[data-pp3d-v15-root] .pp3d-entry-trust-item{flex-direction:row!important;align-items:center!important;justify-content:center!important;gap:4px!important;padding:8px 2px!important;min-height:0!important;text-align:left!important}' +
        '[data-pp3d-v15-root] .pp3d-entry-trust-icon{margin:0!important;font-size:13px!important;width:auto!important;height:auto!important}' +
        '[data-pp3d-v15-root] .pp3d-entry-trust-copy span{display:none!important}' +
        '[data-pp3d-v15-root] .pp3d-entry-trust-copy strong{font-size:10.5px!important;letter-spacing:0!important;white-space:nowrap}' +
      '}';
    document.head.appendChild(st);
  }

  function inst() { var r = document.querySelector(ROOT); return r && r.__pp3dV15; }
  function ready(i) { return (i.state.pillows || []).filter(function (p) { return p && p.meshGroup && p.cropCanvas; }); }

  async function saveBlob(blob, name) {
    var fd = new FormData(); fd.append('image', blob, name);
    var r = await fetch(API, { method: 'POST', body: fd });
    var j = await r.json().catch(function () { return {}; });
    if (!r.ok || !j.ok || !j.url) throw new Error(j.message || 'Could not save photo');
    return j.url;
  }
  var printUrls = new WeakMap();
  function origUrl(p) {
    if (!p.originalFile) return Promise.resolve('');
    if (p.__ppOrig && p.__ppOrig.f === p.originalFile) return p.__ppOrig.pr;
    var pr = saveBlob(p.originalFile, p.originalFile.name || 'photo.jpg');
    var rec = { f: p.originalFile, pr: pr }; p.__ppOrig = rec;
    pr.catch(function () { if (p.__ppOrig === rec) p.__ppOrig = null; });
    return pr;
  }
  function printUrl(p) {
    var c = p.cropCanvas;
    if (!printUrls.has(c)) {
      var pr = window.__ppFiles.printBlob(c).then(function (b) { return saveBlob(b, 'print.png'); });
      pr.catch(function () { printUrls.delete(c); });
      printUrls.set(c, pr);
    }
    return printUrls.get(c);
  }
  function previewUrl(p) {
    if (p.__ppPv && p.__ppPv.t === p.thumbUrl && p.__ppPv.c === p.cropCanvas) return p.__ppPv.pr;
    var pr = window.__ppFiles.previewBlob(p).then(function (b) { return saveBlob(b, 'preview.jpg'); });
    var rec = { t: p.thumbUrl, c: p.cropCanvas, pr: pr }; p.__ppPv = rec;
    pr.catch(function () { if (p.__ppPv === rec) p.__ppPv = null; });
    return pr;
  }
  window.__ppSavedUrls = function (p) {
    if (!window.__ppFiles) return Promise.reject(new Error('not ready'));
    return Promise.all([origUrl(p), printUrl(p), previewUrl(p)]).then(function (a) { return { orig: a[0], print: a[1], preview: a[2] }; });
  };

  function box() { return document.querySelector('[data-pp-xb]'); }
  function form() { return document.getElementById('pp-xb-form'); }
  function setField(f, name, val) {
    var el = f.querySelector('[data-pp-xb-prop="' + name + '"]');
    if (!el) return; el.value = val || ''; el.disabled = !val;
  }
  function setState(s) { var b = box(); if (b) b.setAttribute('data-state', s || 'ready'); }

  function openUpload(i) {
    var entryBtn = document.querySelector('.pp3d-entry-upload-btn');
    if (entryBtn && entryBtn.offsetParent) { entryBtn.click(); return; }
    try { i.openUploadModal(i.state.activeSlotIndex || 0); } catch (_) {}
  }

  var token = 0;
  async function sync() {
    var i = inst(), f = form(); if (!i || !f) return;
    var list = ready(i);
    if (list.length === 0) { setState('nophoto'); return; }
    if (list.length > 1) { setState('multi'); return; }
    var p = list[0], size = i.getSize(p.size);
    if (!size || !size.id) { setState('busy'); return; }
    f.querySelector('[data-pp-xb-variant]').value = String(size.id);
    setField(f, 'Pillow Size', size.label);
    setField(f, 'Border Color', p.borderColor);
    setField(f, 'Notes', (p.note || '').trim());
    var my = ++token;
    if (!(p.__ppDone && p.__ppDone.c === p.cropCanvas && p.__ppDone.t === p.thumbUrl)) setState('busy');
    try {
      var u = await window.__ppSavedUrls(p);
      if (my !== token) return;
      setField(f, 'Original Photo', u.orig);
      setField(f, 'Pillow Preview', u.preview);
      setField(f, '_Print File', u.print);
      p.__ppDone = { c: p.cropCanvas, t: p.thumbUrl };
      setState('ready');
    } catch (e) { if (my === token) setState('error'); }
  }

  function onLockClick(e) {
    e.preventDefault(); e.stopPropagation();
    var i = inst(); if (!i) return;
    var s = (box() || {}).getAttribute && box().getAttribute('data-state');
    if (s === 'nophoto') return openUpload(i);
    if (s === 'multi') return i.handleAddToCart();
    if (s === 'error') { sync(); try { i.showToast('Saving your photo again… try in a moment.'); } catch (_) {} return; }
    try { i.showToast('Saving your photo… one moment.'); } catch (_) {}
  }

  function place() {
    var i = inst(), b = box(); if (!i || !b) return;
    if (!b.__ppInit) {
      b.__ppInit = true;
      var pay = b.querySelector('.pp-xb__pay');
      var lock = document.createElement('div'); lock.className = 'pp-xb__lock'; lock.setAttribute('aria-hidden', 'true');
      lock.addEventListener('click', onLockClick, true);
      pay.appendChild(lock);
      var hint = document.createElement('div'); hint.className = 'pp-xb__hint'; hint.textContent = 'Saving your photo for express checkout…';
      b.appendChild(hint);
    }
    var lockEl = b.querySelector('.pp-xb__lock');
    var st = b.getAttribute('data-state');
    if (lockEl) lockEl.style.display = (st === 'ready') ? 'none' : 'block';

    var card = document.querySelector('.customizer-card');
    var cardOpen = card && !card.hidden && getComputedStyle(card).display !== 'none';
    var early = document.querySelector('.pp-early');
    if (cardOpen) {
      var add = i.dom && i.dom.addToCartBtn;
      if (add && b.previousElementSibling !== add) add.insertAdjacentElement('afterend', b);
      if (early) early.style.display = 'none';
    } else {
      var entryBtn = document.querySelector('.pp3d-entry-upload-btn');
      if (!entryBtn) return;
      heroHead();
      if (!early) early = buildSizes(i, entryBtn);
      if (early) early.style.display = '';
      if (!b.classList.contains('pp-xb-parked')) { b.classList.add('pp-xb-parked'); document.body.appendChild(b); }
      markSizes(i);
    }
    if (cardOpen) b.classList.remove('pp-xb-parked');
  }

  function heroHead() {
    var scr = document.querySelector('.pp3d-entry-screen');
    if (!scr || scr.querySelector('.pp-hero-head')) return;
    var h = document.createElement('div'); h.className = 'pp-hero-head';
    h.innerHTML = '<h1 class="pp-hero-title">Custom Pet Pillow</h1><p class="pp-hero-sub"><span class="pp-stars">★★★★★</span>5,000+ happy pet parents</p>';
    scr.insertBefore(h, scr.firstChild);
  }
  function fixReviews() {
    [].forEach.call(document.querySelectorAll('.dog-keepsake-section__reviews'), function (el) {
      if (el.textContent.trim() !== '5,000+ happy pet parents') el.textContent = '5,000+ happy pet parents';
    });
  }

  function grid() { return document.querySelector('.size-cards-grid'); }
  function buildSizes(i, entryBtn) {
    var g = grid(); if (!g) return null;
    var cards = [].slice.call(g.querySelectorAll('[data-size]'));
    if (!cards.length) return null;
    var el = document.createElement('div'); el.className = 'pp-early';
    var html = '<div class="pp-early__head"><p class="pp-early__title">Choose your size</p><span class="pp-early__ship">✓ Free shipping</span></div><div class="pp-early__grid">';
    cards.forEach(function (c) {
      var label = ((c.querySelector('.size-card-item__label') || {}).textContent || '').trim();
      var m = label.match(/^(.*?)\s*\((\d+)\)/);
      var name = m ? m[1] : label, inch = m ? m[2] + '"' : '';
      if (/extra\s*large/i.test(name)) name = 'XL';
      var price = ((c.querySelector('.size-card-item__sale') || {}).textContent || '').trim().replace(/\.00$/, '');
      var pop = c.querySelector('.size-card-item__badge') ? '<em class="pp-early__badge">POPULAR</em>' : '';
      html += '<button type="button" class="pp-early__card" data-pp-size="' + c.dataset.size + '">' + pop + '<b>' + name + (inch ? ' ' + inch : '') + '</b><span>' + price + '</span></button>';
    });
    html += '</div>';
    el.innerHTML = html;
    el.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pp-size]'); if (!btn) return;
      var real = grid() && grid().querySelector('[data-size="' + btn.dataset.ppSize + '"]');
      if (real) real.click();
      var ii = inst(); if (ii) { ii.state.selectedSize = btn.dataset.ppSize; (ii.state.pillows || []).forEach(function (p) { if (p && !p.thumbUrl) p.size = btn.dataset.ppSize; }); }
      markSizes(ii);
    });
    entryBtn.insertAdjacentElement('beforebegin', el);
    return el;
  }
  function markSizes(i) {
    if (!i) return;
    var sel = String(i.state.selectedSize || '');
    [].forEach.call(document.querySelectorAll('.pp-early__card'), function (c) { c.classList.toggle('is-on', c.dataset.ppSize === sel); });
  }

  var loading = false, loaded = false;
  function ensureBox() {
    if (box() || loading || loaded) return;
    loading = true;
    fetch(location.pathname + '?section_id=pp-express-buy', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (h) {
        if (!h || box()) return;
        var w = document.createElement('div'); w.innerHTML = h;
        var b = w.querySelector('[data-pp-xb]'); if (!b) return;
        b.style.display = 'none'; document.body.appendChild(b);
        loaded = true; place(); b.style.display = '';
        try { if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init(); } catch (_) {}
      })
      .catch(function () {})
      .then(function () { loading = false; });
  }

  var last = '';
  function tick() {
    var i = inst(); if (!i) return;
    heroHead();
    ensureBox();
    var list = ready(i), p = list[0];
    var sig = list.length + '|' + !!form() + '|' + (p ? [p.size, p.borderColor, p.note, p.thumbUrl && p.thumbUrl.length, p.cropCanvas && p.cropCanvas.width].join(',') : '');
    if (sig !== last) { last = sig; sync(); }
    place();
    fixReviews();
  }
  setInterval(tick, 700);
  document.addEventListener('click', function () { setTimeout(tick, 300); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
})();
